export const JOB_INVITE_BULK_INVITE_REQUEST = 'job/invite-bulk-invite-request'
export const JOB_INVITE_BULK_INVITE_SUCCESS = 'job/invite-bulk-invite-success'
export const JOB_INVITE_BULK_INVITE_FAILED = 'job/invite-bulk-invite-failed'
